import { CloseIcon } from '@chakra-ui/icons';
import { Button, Stack, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

type Props = unknown;

export function VerifyEmailExpired(): JSX.Element {
  const i18nVerifyEmailForm = useTranslations('VerifyEmailForm');

  return (
    <Stack align="center" direction="column" spacing="8">
      <Stack>
        <Stack direction="row" gap="4">
          <CloseIcon alignSelf="center" color="red.400" h="8" w="8" />
          <Text fontSize="xl" fontWeight="bold">
            {i18nVerifyEmailForm('VerificationLinkExpired')}
          </Text>
        </Stack>
        <Text fontSize="lg">{i18nVerifyEmailForm('VerificationLinkSent')}</Text>
      </Stack>
      <Link style={{ width: '100%' }} to={routes.home.href}>
        <Button width="full">{i18nVerifyEmailForm('RedirectHome')}</Button>
      </Link>
    </Stack>
  );
}

export type VerifyEmailExpiredProps = Props;
